
export const partners = [
    'Crecea', 'Apropros', 'Joblife'
] as const;
export type Partner = typeof partners[number];